var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{staticClass:"bg-white border-white w-90"},[_c('b-row',{staticClass:"mt-3"},[_c('div',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v(" A division of three justices will review the decision of the single justice who heard the appeal. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }